<template>
  <v-container fluid>
    <v-row class="mx-auto home-image-container">
      <v-col v-for="image in imageURL" :key="image.url" cols="3">
        <v-card elevation="10" class="edit-home-card">
          <img :src="image.url" alt="image" class="edit-home-image" />
          <v-dialog v-model="dialog" width="500">
            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title>CONFIRM DELETION</v-card-title>
              <br />
              <v-card-text>Once deleted, the image cannot be recovered</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog = false">CANCEL</v-btn>
                <v-btn color="primary" text @click="remove">OK</v-btn>
              </v-card-actions>
            </v-card>
            <template v-slot:activator="{ on }">
              <v-btn
                color="red lighten-2"
                dark
                v-on="on"
                block
                outlined
                @click="dialog = true;selected = image.ref"
                :style="{ border: 'none' }"
              >DELETE</v-btn>
            </template>
          </v-dialog>
        </v-card>
      </v-col>
    </v-row>
    <br />
    <br />
    <v-row class="mx-auto home-edit-container">
      <v-file-input
        multiple
        accept="image/*"
        label="Upload Photo for Home Page"
        filled
        prepend-icon="mdi-camera"
        v-model="values"
      ></v-file-input>
      <v-btn color="success" @click="upload" block>Upload</v-btn>
    </v-row>
    <br />
    <br />
  </v-container>
</template>

<script>
import { app } from "../../utils/firebase";
export default {
  data() {
    return {
      dialog: false,
      datax: "abc",
      values: [],
      imageURL: [],
      overlay: false,
      selected: ""
    };
  },
  methods: {
    upload() {
      // Uploading image
      const storage = app.storage();
      for (let i = 0; i < this.values.length; i++) {
        const imageRef = storage
          .ref()
          .child("home/slider/" + this.values[i].name);
        const file = this.values[i];
        console.log(file);
        imageRef.put(file).then(snapshot => {
          console.log("Uploaded the image!");
          console.log(snapshot);
          storage
            .ref()
            .child(snapshot.metadata.fullPath)
            .getDownloadURL()
            .then(url => {
              this.imageURL.push({
                url,
                ref: snapshot.metadata.fullPath
              });
            });
        });
      }
    },
    remove() {
      this.dialog = false;

      // Create a reference to the file to delete
      var storage = app.storage();
      var desertRef = storage.ref().child(this.selected);

      // Delete the file
      desertRef
        .delete()
        .then(() => {
          // remove it from imageList
          this.imageURL = this.imageURL.filter(
            image => image.ref !== this.selected
          );
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  mounted() {
    // Create a reference under which you want to list
    const list = [];
    const paths = [];
    const storage = app.storage();
    const homeListRef = storage.ref().child("home/slider");

    // Find all the prefixes and items.
    homeListRef
      .listAll()
      .then(res => {
        res.items.forEach(function(itemRef) {
          // All the items under listRef.
          list.push(itemRef.name);
          paths.push(itemRef.fullPath);
        });

        // get all images
        const promises = [];
        for (let item of paths) {
          promises.push(
            storage
              .ref()
              .child(item)
              .getDownloadURL()
          );
        }
        // promises.push(storage.ref().child('home/slider/Summer_Lab.png').getDownloadURL());
        Promise.all(promises).then(dataList => {
          dataList.forEach((url, index) => {
            this.imageURL.push({
              url,
              ref: paths[index]
            });
          });
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
</script>

<style lang="css">
@keyframes scaleToAppear {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

.home-image-container {
  max-width: 80%;
  background: ghostwhite;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  padding: 20px;
}

.home-edit-container {
  max-width: 80%;
}

.edit-home-card {
  cursor: pointer;
  animation: scaleToAppear 1s forwards cubic-bezier(0.075, 0.82, 0.165, 1);
}

.edit-home-image {
  width: 100%;
  height: 150px;
}
</style>